export default {
  highPrecisionAdd(data1, data2) { // 加法
    console.log(data1, data2, 'highPrecisionAdd 入参1  入参2')
    // 如果传入的参数为undefind 或者 null  或者 ''统一做0处理
    if (!data1) {
      data1 = 0
    }
    if (!data2) {
      data2 = 0
    }
    let r1
    let r2
    // 获取每个参数的小数的位数
    try {
      r1 = data1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = data2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    // 计算底数为10以最大小数位数为次幂的值
    const m = Math.pow(10, Math.max(r1, r2))
    // 把所有参数转为整数后相加再除以次幂的值
    // const res = (data1 * m + data2 * m) / m
    const res = this.highPrecisionDiv(this.highPrecisionMul(data1, m) + this.highPrecisionMul(data2, m), m)
    console.log(res, 'highPrecisionAdd 出参')
    return res
  },

  highPrecisionReduce(data1, data2) { // 减法
    console.log(data1, data2, 'highPrecisionReduce 入参1  入参2')
    // 如果传入的参数为undefind 或者 null 或者 '' 统一做0处理
    if (!data1) {
      data1 = 0
    }
    if (!data2) {
      data2 = 0
    }
    let r1
    let r2
    // 获取每个参数的小数的位数
    try {
      r1 = data1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = data2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    // 计算底数为10以最大小数位数为次幂的值
    const m = Math.pow(10, Math.max(r1, r2))
    // 精度长度以最大小数位数为长度
    const n = (r1 >= r2) ? r1 : r2
    // const res = ((data1 * m - data2 * m) / m).toFixed(n)
    const res = this.highPrecisionDiv(this.highPrecisionMul(data1, m) - this.highPrecisionMul(data2, m), m).toFixed(n)
    console.log(res, 'highPrecisionReduce 出参')
    return res
  },
  highPrecisionMul(data1, data2) { // 乘法
    console.log(data1, data2, 'highPrecisionMul 入参1  入参2')
    // 如果传入的参数为undefind 或者 null 或者 '' 统一做0处理
    if (!data1 || !data2) {
      return 0
    }
    let m = 0
    const s1 = data1.toString()
    const s2 = data2.toString()
    // 获取所有参数小数位长度之和
    try {
      m += s1.split('.')[1].length
    } catch (e) {
      // console.error(e.message, 'highPrecisionMul')
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
      // console.error(e.message, 'highPrecisionMul')
    }
    // 替换掉小数点转为数字相乘再除以10的次幂值
    const res = Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    console.log(res, 'highPrecisionMul 出参')
    return res
  },
  highPrecisionDiv(data1, data2) { // 除法
    console.log(data1, data2, 'highPrecisionDiv 入参1  入参2')
    // 如果传入的参数为undefind 或者 null 或者 '' 统一做0处理
    if (!data1 || !data2) {
      return 0
    }
    let t1 = 0
    let t2 = 0
    // 获取每个参数的小数的位数
    try {
      t1 = data1.toString().split('.')[1].length
    } catch (e) {
      // console.error(e.message, 'highPrecisionDiv报错')
    }
    try {
      t2 = data2.toString().split('.')[1].length
    } catch (e) {
      // console.error(e.message, 'highPrecisionDiv报错')
    }
    // 把所有参数的小数点去掉转为整数
    const r1 = Number(data1.toString().replace('.', ''))
    const r2 = Number(data2.toString().replace('.', ''))
    // const res = (r1 / r2) * Math.pow(10, t2 - t1)
    const res = this.highPrecisionMul((r1 / r2), Math.pow(10, t2 - t1))
    console.log(res, 'highPrecisionDiv 出参')
    return res
  }
}



// WEBPACK FOOTER //
// ./src/utils/math.js